import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54ea15f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-container" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title-dialog" }, "Bloquer un utilisateur")
], -1))
const _hoisted_2 = { class: "form-container mt-3" }
const _hoisted_3 = { class: "row mt-5" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check-label fw-bold" }, "Etat :", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-100 mb-4" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1))
const _hoisted_8 = { class: "col" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label fw-bold mb-3",
  for: "comment"
}, [
  /*#__PURE__*/_createTextVNode(" Commentaire "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*"),
  /*#__PURE__*/_createTextVNode(" : ")
], -1))
const _hoisted_10 = { class: "footer-container" }

import {BlacklistResponseOnPost, blacklistUser} from "@/_services/blackList/blacklist";
import {useAuthStore} from "@/stores/auth/authStore";
import {ref, computed, reactive} from "vue";
import {useRouter} from "vue-router";
import swal from "@/_helpers/swal";
import Dialog from 'primevue/dialog';

const BLACKLIST_OPTION_VALUE = "0";

export default /*#__PURE__*/_defineComponent({
  __name: 'UserBlackListModal',
  props: {
    userUuid: {
        type: String,
        required: true,
    },
    visible: {
        type: Boolean,
        required: true,
        default: false,
    },
},
  emits: ['confirm', 'update:visible'],
  setup(__props, { emit }) {

const props = __props;

const router = useRouter();
const authStore = useAuthStore();



const isFormSubmitting = ref<boolean>(false);
const userUuid = computed(() => props.userUuid);

const formOptions = [
    {
        label: "Blacklister - L'utilisateur sera bloqué et ne pourra plus se connecter à son compte.",
        value: BLACKLIST_OPTION_VALUE
    },
];

const isCommentNotEmpty = (node): boolean => {
    let comment= node.value;
    const regex = new RegExp(/\S/);
    
    return regex.test(comment);
};

const closeDialog = (): void => {
    emit('update:visible', false);
    resetFormData();
};

const formData = reactive({
    comment: '',
});

const resetFormData = (): void => {
    formData.comment = '';
};

const onSubmitForm = async (formData: object, formNode) => {
    isFormSubmitting.value = true;
    const currentUserAdminUuid = authStore.getCurrentUserUuid();
    if (currentUserAdminUuid) {
        await blacklistUser(userUuid.value, true, formData.comment)
            .then((result: BlacklistResponseOnPost | null) => {
                if (result) {
                    router.push({ name: 'UserBlacklistHistorique', params: { uuid: result.blacklistUuid } });
                } else {
                    isFormSubmitting.value = true;
                    swal.error("Le traitement a echoué");
                }
            })
            .catch((error) => {
                isFormSubmitting.value = true;
                console.dir(error);
                swal.error("Le traitement a echoué");
            });
    }
};

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: __props.visible,
    class: "dialog-container custom-dialog",
    modal: "",
    style: { width: '30rem' },
    closable: false
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_FormKit, {
          type: "form",
          id: "blacklistUserFormModal",
          onSubmit: onSubmitForm,
          actions: false,
          "incomplete-message": "Désolé, tous les champs ne sont pas remplis correctement."
        }, {
          default: _withCtx(({ state: { valid } }) => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _hoisted_6,
                _createVNode(_component_FormKit, {
                  type: "radio",
                  name: "isBlackListed",
                  "model-value": "0",
                  class: "form-check-inline",
                  options: formOptions,
                  help: "L'utilisateur sera bloqué et ne pourra plus se connecter à son compte."
                })
              ]),
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_FormKit, {
                  type: "textarea",
                  name: "comment",
                  class: "form-comment",
                  validation: "required|length:1,255|isCommentNotEmpty",
                  "validation-rules": { isCommentNotEmpty: isCommentNotEmpty },
                  "validation-messages": {
                                    required: 'Veuillez entrer une description.',
                                    length: 'Ce champ doit contenir maximum 255 caractères.',
                                    isCommentNotEmpty: 'Veuillez entrer une description.',
                            }
                }, null, 8, ["validation-rules", "validation-messages"])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_FormKit, {
                type: "button",
                label: "Annuler",
                onClick: closeDialog,
                class: "mr-2 button-cancel",
                style: {"background-color":"#ff4d4d","color":"white"}
              }),
              _createVNode(_component_FormKit, {
                type: "submit",
                label: "Valider",
                class: "button-confirm",
                disabled: !valid || isFormSubmitting.value
              }, null, 8, ["disabled"])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})